import CopyrightFooter from './CopyrightFooter';

export default CopyrightFooter;
